<template>
  <div>
    <h1>Título</h1>
    <input
      v-model="titulo"
      type="text"
    >

    <h2>Descrição</h2>
    <textarea v-model="descricao" />

    <button @click="confirm()">
      Confirmar
    </button>
    <button @click="close()">
      Cancelar
    </button>
  </div>
</template>

<script>
import { bus } from '@/main'

export default {
    name: "NovoCurso",
    data() {
        return {
            titulo: "",
            descricao: ""
        }
    },
    methods: {
        close() {
            this.$emit("input")
        },
        confirm() {
            bus.$emit("novosDados", {titulo: this.titulo, descricao: this.descricao})
            this.$emit("input")
        }
    }
}
</script>

<style>

</style>